import { TableColumn } from "./Table"

export enum LookupTableId {
    platform = "platform",
    sensor = "sensor",
    acquisition_mode = "acquisition_mode",
}

export const lookupTablesMap: Map<LookupTableId, { label: string }> = new Map()
lookupTablesMap.set(LookupTableId.platform, { label: "Platforms" })
lookupTablesMap.set(LookupTableId.sensor, { label: "Sensors" })
lookupTablesMap.set(LookupTableId.acquisition_mode, { label: "Acquisition Mode" })

export type LookupDataType = {
    [key: string]: string | number | null | boolean | undefined
}

export type LookupTableResponse = {
    rows: LookupDataType[]
    columns: TableColumn<LookupDataType>[]
}
